<template>
      <div v-for="(value,key) in part_arr" track-by="$index" class="voucher-main-container col-span-4 lg:col-span-3 md:col-span-4 sm:col-span-3">
            <div class="yellow-section" style="background-color: #e0f1fc">
              <h6 class="pt-1 pl-2 pr-2">
                <span class="voucher-heading">PART</span>
                  <span
                    ><button
                      id="attribute_button"
                      class="inventory-submit-btn ml-2"
                      style="float: right"
                      @click="addAttribute($event,value)"
                      type="submit"
                    >
                      A
                    </button></span
                  >
                   <span
                  ><button
                    id="TopLine"
                    class="inventory-submit-btn ml-2"
                    style="float: right"
                    @click="addLine(value,'TOPLINE')"
                    type="submit"
                  >
                    TL
                  </button></span
                >
                 <span
                  ><button
                    id="BottomLine"
                    class="inventory-submit-btn ml-2"
                    style="float: right"
                    @click="addLine(value,'BOTTOMLINE')"
                    type="submit"
                  >
                    BL
                  </button></span
                >
                <span
                  ><button
                    id="report_button"
                    class="inventory-submit-btn ml-2"
                    style="float: right"
                    @click="removePart(value)"
                    type="submit"
                  >
                    -
                  </button></span
                >
              </h6>
            </div>
            <hr class="voucher-hr">
                         <div class="grid grid-cols-3 gap-1 px-5 pt-5 -mb-8">
                              <label for="" class="col-span-1 -pl-2">Name:</label>
                              <input class="form-input px-4 rounded-half w-half h-6 " type="text" v-model="value.name"  @input="saveDataView()">
                          </div>
                          <br>
                          <br>
            <div style="padding-bottom:1%; ">
              
                          <div v-for="(val,index_at) in value.ATTRIBUTE" class="px-3 "> 
                           
                            <div  class=" grid grid-cols-3 gap-4 ">
                                <div class="col-span-1" >
                                    <input class="px-4 rounded-half w-full h-6 mb-1" style="border:1px solid black;" v-model="val.name" list="attributes" name="select_attribute"    id="select_attribute" @input="setValueInputType(val,$event)" autocomplete="off"/>
                                    <datalist id="attributes">
                                      <option v-for="(val_a_p,index) in this.attribute_json" :value="val_a_p.name" >{{val_a_p.name}}</option>
                                    </datalist>
                                      <!-- <select class="px-4 rounded-half w-full h-10" :name="val.name" :value="val.name" v-model="val.name" id="" @change="setValueInputType(val,$event)">
                                        <option v-for="(val_a_j,index) in attribute_json_value" :value="val_a_j.name" >{{val_a_j.name}}</option>
                                      </select> -->
                                  </div>
                                  <div class="col-span-1 value_box text_box" >
                                    <input class="form-input px-4 rounded-half w-full h-6 mb-1" type="text" v-model="val.value" @input="saveDataView()">
                                  </div>
                                  <div class="col-span-1 value_box dropdown" style="display:none;">
                                        <input class="px-2 rounded-half w-full h-6 mb-1" style="border:1px solid black;" v-model="val.value" list="sec_attribute" name="select_attribute"  id="select_attribute"  autocomplete="off" @input="saveDataView()"/>
                                        <datalist  id="sec_attribute" class="dropdown" >
                                            <!-- <option v-for="(val_a_d,index) in bar('val_a_j')" >{{val_a_d.name}}</option> -->
                                        </datalist>
                                  </div>
                                  <div class="col-span-1">
                                      <span
                                        ><button
                                          id="attribute_button"
                                          class="inventory-submit-btn ml-2"
                                          style="float: left"
                                          @click="removeAttribute(value,index_at)"
                                          type="submit"
                                        >
                                          -
                                        </button></span
                                      >
                                </div>
                              </div>
                          </div>
                          <div >
                              <!-- Inventory starts -->
                                   <div v-for="(v_l,k_l) in value" track-by="$index">
                                        <div  class='key_data voucher-label ml-3' v-if="k_l=='LINE'" >
                                                <reportline :line_arr="v_l"  @addField="addField($event,field_type)" @saveDataView="saveDataView()"/>
                                        </div>
                              </div>
                              <!-- Inventory ends -->   
                    </div>
            </div>
    </div>
</template>

<script>
import reportline from './line';
import attribute_json from '../json/part_attribute.json';

export default {
    emits:["saveDataView"],
    components:{
        reportline
    },
    props:{
        part_arr:{
          type:Array,
          default: {}
        },
    },
    data:function(){
        return{
            ATTRIBUTE:[],
            line_type:"",
            LINE:[],
            attribute_json:attribute_json,

        }
    },
    methods:{
        addLine(obj,line_type){
            this.line_type=line_type;
             var txtVal = 'LINE';
                  if (!(txtVal in obj)) {
                      this.LINE = [{
                          "heading":line_type,
                          "type":"LINE",
                          ATTRIBUTE:[],
                      }];
                      obj.LINE = this.LINE;
                  }
                  else if ((txtVal in obj)) {
                      this.LINE = {
                          "heading":line_type,
                          "type":"LINE",
                          ATTRIBUTE:[],
                      }
                      obj.LINE.push(this.LINE);
                  }
              this.saveDataView();
        },
        addAttribute(obj,value){
              if (obj.target.attributes.id.value == 'attribute_button') {
                var txtVal = 'ATTRIBUTE';
                if (!(txtVal in value)) {
                    this.ATTRIBUTE = [{
                       "name":"",
                       "value":""
                    }];
                    value.ATTRIBUTE = this.ATTRIBUTE;
                }
                else if ((txtVal in value)) {
                    value.ATTRIBUTE.push({
                        "name":"",
                        "value":""
                    });
                }
              }
              this.saveDataView();
          },
          removePart(index){
              this.part_arr.splice(index,1)
              this.saveDataView();
          },
           removeAttribute(value,index){
              value.ATTRIBUTE.splice(index,1)
              this.saveDataView();
          },
          setValueInputType(value,e){
              //loop on json containing attributes
              attribute_json.forEach(function(val,key){
                 if(value.name == val.name){
                   //loop on input html elements
                   for(var i=0;i<e.target.parentElement.parentElement.children.length;i++){
                     //check if a div element contains the given type in the name object
                     if(e.target.parentElement.parentElement.children[i].getAttribute('class').indexOf("value_box") != -1){
                            e.target.parentElement.parentElement.children[i].style.display = "none";
                     }
                     if(e.target.parentElement.parentElement.children[i].getAttribute('class').indexOf(val.type) != -1 ){
                            //changing style of display from none to block 
                            e.target.parentElement.parentElement.children[i].style.display = "block";
                            if(val.type == "dropdown"){
                              //add options to the select tag 
                              val.option.forEach(function(value,key){
                                var option = document.createElement("option");
                                option.text = value;
                                option.value = value;
                                e.target.parentElement.parentElement.children[i].children[1].append(option);
                              })
                            }
                     }
                   }
                 }
              })
              this.saveDataView();
          },
          saveDataView(){
              this.$emit('saveDataView')
          }
    },
    mounted(){
    }
}
</script>
<style>

</style>